export default function LoveFestival202526() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-purple-50 via-pink-50 to-rose-50">
      {/* メインコンテンツ */}
      <main className="max-w-4xl mx-auto px-6 py-16">
        {/* タイトルセクション */}
        <section className="text-center mb-16">
          <div className="inline-block bg-gradient-to-r from-purple-600 via-pink-600 to-rose-600 text-white px-8 py-3 rounded-full text-2xl font-bold mb-8 shadow-lg animate-pulse">
            【祝福の大祭典】
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-transparent bg-clip-text bg-gradient-to-r from-purple-600 via-pink-600 to-rose-600" style={{ fontFamily: "'Noto Serif JP', serif", letterSpacing: '0.1em' }}>
            ご登録ありがとうございます✨
          </h1>
        </section>

        {/* 重要なお知らせ */}
        <section className="mb-12">
          <div className="bg-white rounded-3xl p-10 shadow-2xl border-2 border-purple-200">
            <div className="text-center mb-8">
              <div className="inline-block bg-gradient-to-r from-purple-100 to-pink-100 px-6 py-3 rounded-full border-2 border-purple-300 mb-6">
                <p className="text-purple-900 font-bold text-xl">＼大切なお知らせです／</p>
              </div>
              
              <h2 className="text-3xl font-bold text-gray-800 mb-6 leading-relaxed">
                祝福の大祭典の《ご参加案内》は<br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600 text-4xl">【公式LINEでのみ】</span><br />
                お届けいたします。
              </h2>
            </div>

            {/* 説明文 */}
            <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-8 mb-8 border border-purple-200">
              <p className="text-gray-700 text-lg leading-relaxed text-center mb-6">
                祝福の大祭典は、<br />
                クリスタルの祝福と魂の調整が起きる<br />
                <strong className="text-purple-700 text-xl">"特別なエネルギー空間"</strong>です。
              </p>
            </div>

            {/* 案内内容 */}
            <div className="mb-8">
              <p className="text-gray-700 text-lg text-center mb-6">そのため、</p>
              
              <div className="space-y-4">
                <div className="bg-white rounded-xl p-6 shadow-md border-l-4 border-purple-500">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-purple-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-video-line text-white text-xl"></i>
                    </div>
                    <p className="text-gray-800 font-bold text-lg">当日の【視聴リンク】</p>
                  </div>
                </div>

                <div className="bg-white rounded-xl p-6 shadow-md border-l-4 border-pink-500">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-pink-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-heart-pulse-line text-white text-xl"></i>
                    </div>
                    <p className="text-gray-800 font-bold text-lg">エネルギーワークの【受け取り準備】</p>
                  </div>
                </div>

                <div className="bg-white rounded-xl p-6 shadow-md border-l-4 border-rose-500">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-rose-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-message-3-line text-white text-xl"></i>
                    </div>
                    <p className="text-gray-800 font-bold text-lg">参加者だけの【クリスタルメッセージ】</p>
                  </div>
                </div>
              </div>
            </div>

            {/* LINE限定案内 */}
            <div className="bg-gradient-to-r from-purple-100 via-pink-100 to-rose-100 rounded-2xl p-8 mb-8 border-2 border-purple-300">
              <p className="text-gray-700 text-lg text-center mb-4 leading-relaxed">
                これらの大切なご案内を、<br />
                確実に受け取っていただくために
              </p>
              
              <div className="text-center">
                <div className="inline-block bg-gradient-to-r from-purple-600 via-pink-600 to-rose-600 text-white px-8 py-4 rounded-2xl text-2xl font-bold shadow-lg">
                  ✨《LINE限定》✨
                </div>
                <p className="text-gray-700 text-lg mt-4">でお届けしています。</p>
              </div>
            </div>

            {/* 注意事項 */}
            <div className="bg-rose-50 rounded-xl p-6 border-l-4 border-rose-500 mb-10">
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0">
                  <i className="ri-alert-fill text-rose-600 text-2xl"></i>
                </div>
                <p className="text-rose-800 font-bold text-lg">
                  ※メールでは届かないケースが<br />多いためご注意ください。
                </p>
              </div>
            </div>

            {/* CTAボタン */}
            <div className="text-center">
              <a 
                href="https://liff.line.me/2007623509-YDjVXOWb/landing?follow=%40swi1918i&lp=gzZ32E&liff_id=2007623509-YDjVXOWb"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-gradient-to-r from-purple-600 via-pink-600 to-rose-600 hover:from-purple-700 hover:via-pink-700 hover:to-rose-700 text-white px-12 py-6 rounded-full text-xl font-bold shadow-2xl transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <div className="flex items-center gap-3">
                  <i className="ri-line-fill text-3xl"></i>
                  <span>参加登録を完了させる</span>
                </div>
              </a>
            </div>
          </div>
        </section>

        {/* 装飾的な要素 */}
        <div className="text-center">
          <div className="inline-flex items-center gap-2 text-purple-400 text-4xl">
            <i className="ri-sparkling-2-fill animate-pulse"></i>
            <i className="ri-sparkling-fill animate-pulse" style={{ animationDelay: '0.2s' }}></i>
            <i className="ri-sparkling-2-fill animate-pulse" style={{ animationDelay: '0.4s' }}></i>
          </div>
        </div>
      </main>

      {/* フッター */}
      <footer className="bg-gradient-to-r from-purple-100 via-pink-100 to-rose-100 py-12 border-t-2 border-purple-200 mt-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center">
            <div className="border-t border-purple-300 pt-6">
              <p className="text-purple-800 text-sm">Copyright © Dynavision Co.,Ltd. All Rights Reserved.</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}